module.exports = __webpack_public_path__ + "img/icon5.dbe34811.png";